<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="114px"
    >
      <el-form-item label="用户" prop="userId">
        <el-select
          v-model="queryParams.userId"
          placeholder="请选择用户"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in userList"
            :key="index"
            :label="item.userName"
            :value="item.userId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称" prop="goodsName">
        <el-input
          v-model="queryParams.goodsName"
          placeholder="请输入商品名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="commentList">
      <el-table-column
        label="订单ID"
        align="center"
        prop="orderId"
        show-overflow-tooltip
      />
      <el-table-column
        label="商品名称"
        align="center"
        prop="goodsName"
        show-overflow-tooltip
      />

      <el-table-column
        label="用户名"
        align="center"
        prop="nickName"
        show-overflow-tooltip
      />
      <el-table-column
        label="内容"
        align="center"
        prop="content"
        show-overflow-tooltip
      />
      <el-table-column
        label="回复"
        align="center"
        prop="replyContent"
        show-overflow-tooltip
      />
      <el-table-column label="是否匿名" align="center" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.isAnonymous == 1">匿名</span>
          <span v-if="row.isAnonymous == 0">公开</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!-- <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              >修改</el-button
            > -->
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-if="storeId == 0"
            >删除</el-button
          >
          <el-button
            size="mini"
            type="text"
            :visible.sync="dialogFormVisible"
            @click="handleHuiFu(scope.row)"
            >回复</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 回复弹窗 -->
    <el-dialog
      title="回复"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="huiFu">
        <el-form-item class="formLabelWidth" label="回复" prop="replyContent">
          <el-input
            v-model="huiFu.replyContent"
            autocomplete="off"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加或修改订单评价对话框 -->
    <el-drawer :title="title" :visible.sync="open" size="26%" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入用户ID" />
        </el-form-item>
        <el-form-item label="订单ID" prop="orderId">
          <el-input v-model="form.orderId" placeholder="请输入订单ID" />
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsId">
          <el-input v-model="form.goodsId" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="商品评价" prop="goodsScore">
          <el-input v-model="form.goodsScore" placeholder="请输入商品评价" />
        </el-form-item>
        <el-form-item label="服务评价" prop="serviceScore">
          <el-input v-model="form.serviceScore" placeholder="请输入服务评价" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <editor v-model="form.content" :min-height="192"  />
        </el-form-item>
        <el-form-item label="回复" prop="replyContent">
          <editor v-model="form.replyContent" :min-height="192" />
        </el-form-item>
        <el-form-item label="是否匿名评价" prop="isAnonymous">
          <el-input
            v-model="form.isAnonymous"
            placeholder="请输入是否匿名评价"
          />
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
    
    <script>
import {
  listComment,
  delComment,
  addComment,
  updateComment,
} from "@/api/comment";
import { getOrderUserName } from "@/api/order";

export default {
  name: "Comment",
  dicts: ["status"],
  data() {
    return {
      storeId: "",
      disabled: false,
      id: null,
      dialogFormVisible: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 订单评价表格数据
      commentList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platformId: this.$route.query.platformId,
        userId: null,
        orderId: null,
        goodsId: null,
        goodsScore: null,
        serviceScore: null,
        nickName: null,
        content: null,
        replyContent: null,
        isAnonymous: null,
        status: null,
        orderId: null,
      },
      //
      huiFu: {
        id: null,
        userId: null,
        orderId: null,
        goodsId: null,
        goodsScore: null,
        serviceScore: null,
        nickName: null,
        content: null,
        replyContent: null,
        isAnonymous: null,
        status: null,
        createTime: null,
        updateTime: null,
      },
      // 表单参数
      form: {
        id: null,
        userId: null,
        orderId: null,
        goodsId: null,
        goodsScore: null,
        serviceScore: null,
        nickName: null,
        content: null,
        replyContent: null,
        isAnonymous: null,
        status: null,
        createTime: null,
        updateTime: null,
      },
      userList: [],
      // 表单校验
      rules: {
        userId: [
          { required: true, message: "用户ID不能为空", trigger: "blur" },
        ],
        orderId: [
          { required: true, message: "订单ID不能为空", trigger: "blur" },
        ],
        goodsId: [
          { required: true, message: "商品ID不能为空", trigger: "blur" },
        ],
        goodsScore: [
          { required: true, message: "商品评价不能为空", trigger: "blur" },
        ],
        serviceScore: [
          { required: true, message: "服务评价不能为空", trigger: "blur" },
        ],
        isAnonymous: [
          { required: true, message: "是否匿名评价不能为空", trigger: "blur" },
        ],
        status: [
          { required: true, message: "状态不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getList();
    this.storeId = this.$route.query.storeId;
    this.getOrderUserName();
  },
  methods: {
    // 获取用户下拉框
    getOrderUserName() {
      getOrderUserName({
        platformId: this.$route.query.platformId,
        storeId: this.$route.query.storeId,
      }).then((res) => {
        if (res.code == 200) {
          this.userList = res.data;
        }
      });
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 查询订单评价列表 */
    getList() {
      this.loading = true;
      listComment(this.queryParams).then((response) => {
        this.commentList = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        userId: null,
        orderId: null,
        goodsId: null,
        goodsScore: null,
        serviceScore: null,
        nickName: null,
        content: null,
        replyContent: null,
        isAnonymous: null,
        status: null,
        createTime: null,
        updateTime: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加订单评价";
    },

    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateComment(this.form).then((response) => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addComment(this.form).then((response) => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm("是否确认删除该评价？", {
        type: "warning",
      })
        .then(function () {
          return delComment(ids);
        })
        .then(() => {
          this.getList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
    // 回复按钮
    handleHuiFu(row) {
      this.dialogFormVisible = true;
      this.id = row.id;
      // console.log("this.form.id", this.form.id);
      // console.log("huifu");
    },
    /** 修改按钮操作 */
    handleUpdate() {
      updateComment({
        id: this.id,
        replyContent: this.huiFu.replyContent,
      }).then((res) => {
        this.$message({
          message: "回复成功",
          type: "success",
        });
        this.getList();
        this.disabled = true;
      });

      this.dialogFormVisible = false;
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        "system/comment/export",
        {
          ...this.queryParams,
        },
        `comment_${new Date().getTime()}.xlsx`
      );
    },
  },
};
</script>
  <style scoped>
.formLabelWidth {
  width: 50%;
  margin: 0 auto;
}
</style>
    